import 'extensions/ui-components/x-date-input';
import {FormElementMixin} from 'extensions/ui-mixins/form-element/lib/form-element-mixin';
import {defineCustomElement} from 'extensions/ui-utils';
import {LitElement, html} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import stylesheet from './x-mord-group-multisystem.scss?as=stylesheet';

// eslint-disable-next-line new-cap
export class ModifyOrderGroupMultisystem extends FormElementMixin(LitElement) {
	static get styles () {
		return [stylesheet];
	}

	// eslint-disable-next-line max-lines-per-function
	static get properties () {
		return {
			baseSubtotal: {
				attribute: 'base-subtotal',
				type: Number
			},
			deliveryDate: {
				attribute: 'delivery-date',
				type: String
			},
			formattedBaseSubtotal: {
				attribute: 'formatted-base-subtotal',
				type: String
			},
			formattedDeliveryDate: {
				attribute: 'formatted-delivery-date',
				type: String
			},
			formattedSubtotal: {
				attribute: 'formatted-subtotal',
				type: String
			},
			hidePricing: {
				attribute: 'hide-pricing',
				type: Boolean
			},
			id: {
				type: String
			},
			image: {
				type: String
			},
			quantity: {
				type: Number
			},
			subtotal: {
				type: Number
			}
		};
	}

	// eslint-disable-next-line max-lines-per-function
	constructor () {
		super();

		/**
		 * @type {number}
		 */
		this.baseSubtotal = 0;

		/**
		 * @type {string}
		 */
		this.deliveryDate = '';

		/**
		 * @type {string}
		 */
		this.formattedDeliveryDate = '';

		/**
		 * @type {string}
		 */
		this.formattedBaseSubtotal = '';

		/**
		 * @type {string}
		 */
		this.formattedSubtotal = '';

		/**
		 * @type {boolean}
		 */
		this.hidePricing = false;

		/**
		 * @type {string}
		 */
		this.id = '';

		/**
		 * @type {string}
		 */
		this.image = '';

		/**
		 * @type {number}
		 */
		this.quantity = 0;

		/**
		 * @type {number}
		 */
		this.subtotal = 0;

		/**
		 * @type {object}
		 */
		this.formattedValues = {};
	}

	connectedCallback () {
		super.connectedCallback();

		this.updateValue();
	}

	// eslint-disable-next-line max-lines-per-function
	renderInnerForm () {
		const classes = {
			container: true
		};

		return html`
			<div class="${classMap(classes)}">
				<div class="inner-container">
					<div class="info">
						<div class="image">
							<img src="${this.image}" loading="lazy" class="image-source" />
						</div>
						<div class="info-name">
							Multi System
						</div>
					</div>
					<div class="details">
						<div class="actions">
							${this.renderDeliveryDate()}
							<div class="quantity">
								QTY: ${this.quantity}
							</div>
						</div>
						<div class="details-right">
							<div class="pricing">
								${this.renderPricing()}
							</div>
						</div>
					</div>
				</div>
				<div class="slots">
					<slot></slot>
				</div>
			</div>
		`;
	}

	renderDeliveryDate () {
		return html`
			<div class="delivery-date-form">
				<x-date-input disable-weekends name="DatePicker" value="${this.dateTimeFormat}" @change="${this.handleDateChange}"></x-date-input>
			</div>
		`;
	}

	renderPricing () {
		if (!this.hidePricing) {
			return html`
				<div class="pricing-subtotal">
					${this.formattedSubtotal}
				</div>
			`;
		}

		return html`
			<div class="pricing-subtotal">
				<span class="hide-pricing"></span>
			</div>
		`;
	}

	async handleDateChange (e) {
		const dateElement = e.target;
		let newDate = '';
		if (dateElement?.value !== '') {
			const date = new Date(dateElement?.value);
			newDate = date.toISOString().substring(0, 19);
		}

		if (this.deliveryDate === newDate) {
			return;
		}

		this.deliveryDate = newDate;

		await this.updateComplete;

		this.updateValue();
	}

	updateValue () {
		this.formattedValues = {
			date: this.deliveryDate,
			id: this.id,
			lineId: this.lineId,
			quantity: this.quantity
		};
	}

	get dateTimeFormat () {
		if (!this.deliveryDate) {
			return '';
		}

		const d = new Date(this.deliveryDate);
		return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
	}
};

defineCustomElement('x-mord-group-multisystem', ModifyOrderGroupMultisystem);
